/**
 * Helpers Functions
 */
import moment from "moment";
import tranlations from "../constants/translate";
import { store } from "../store/store";
import { list_building } from "../constants/db-config";
moment.locale("vi");
// Get Date
export function getTheDate(timestamp, format) {
    let time = timestamp * 1000;
    let formatDate = format ? format : "MM-DD-YYYY";
    return moment(time).format(formatDate);
}

// Get Current Month
export function getCurrentMonth(date) {
    var d = date ? new Date(date) : new Date();
    return d.getMonth() + 1;
}

// Convert Date To Timestamp
export function convertDateToTimeStamp(date, format) {
    let formatDate = format ? format : "YYYY-MM-DD";
    return moment(date, formatDate).unix();
}
export function formatTimeServer(serverDate, format = "DD-MMM-YYYY") {
    return moment(serverDate).format(format);
}
/**
 * Text Truncate
 */
export function textTruncate(str, length, ending) {
    if (length == null) {
        length = 100;
    }
    if (ending == null) {
        ending = "...";
    }
    if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
    } else {
        return str;
    }
}

/**
 * Function to convert hex to rgba
 */
export function hexToRgbA(hex, alpha) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
            "rgba(" +
            [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
            "," +
            alpha +
            ")"
        );
    }
    throw new Error("Bad Hex");
}

/**
 * Function to return currenr app layout
 */
export function getCurrentAppLayout(router) {
    let location = router.history.current.fullPath;
    let path = location.split("/");
    return path[1];
}

export function buildParamQuery(params) {
    let esc = encodeURIComponent;
    let key_array = [];
    for (const key in params) {
        if (
            params.hasOwnProperty(key) &&
            (params[key] || params[key] === false || params[key] === 0)
        ) {
            key_array.push(key);
        }
    }
    let query = key_array.map((k) => esc(k) + "=" + esc(params[k])).join("&");
    return query;
}
export function round_to_precision(x, precision) {
    var y = +x + (precision === undefined ? 0.5 : precision / 2);
    return y - (y % (precision === undefined ? 1 : +precision));
}
export function deepCopy(aObject) {
    if (!aObject || typeof aObject !== "object") {
        return aObject;
    }

    let v;
    let bObject = Array.isArray(aObject) ? [] : {};
    for (const k in aObject) {
        v = aObject[k];
        bObject[k] = typeof v === "object" ? deepCopy(v) : v;
    }

    return bObject;
}
export function dayDiff(a, b) {
    return moment(a).diff(moment(b), "days");
}

export function translateText(str) {
    return tranlations[str.toLowerCase()] || str;
}

export function getJsDateFromExcel(excelDate) {
    // JavaScript dates can be constructed by passing milliseconds
    // since the Unix epoch (January 1, 1970) example: new Date(12312512312);

    // 1. Subtract number of days between Jan 1, 1900 and Jan 1, 1970, plus 1 (Google "excel leap year bug")
    // 2. Convert to milliseconds.

    return new Date((Number(excelDate) - (25567 + 2)) * 86400 * 1000);
}
export function translateWalletName(id) {
    const wallets = store.state.app.wallets;
    const found_wallet = wallets.find((wallet) => wallet.id == id);
    return found_wallet ? found_wallet.name : "N/F";
}

export function translateBuildingName(chosen_building) {
    const found_building = list_building.find(
        (building) => building.value == chosen_building
    );
    return found_building ? found_building.text : "";
}

export function roomByBuilding(room_data) {
    const virtual_room_data = deepCopy(room_data);
    const gb = virtual_room_data.filter((room) => room.building === "GB");
    const tt = virtual_room_data.filter((room) => room.building === "TT");
    const mt = virtual_room_data.filter((room) => room.building === "MT");
    const bn = virtual_room_data.filter((room) => room.building === "BN");
    const a = virtual_room_data.filter((room) => {
        const last_char = room.room_id[room.room_id.length - 1];
        return room.building != "MA" && last_char == "A";
    });
    const b = virtual_room_data.filter((room) => {
        const last_char = room.room_id[room.room_id.length - 1];
        return room.building != "GB" && last_char == "B";
    });
    const ma = virtual_room_data.filter((room) => room.building === "MA");
    return [gb, tt, mt, bn, a, b, ma];
}

export function translateAgentName(agent_id) {
    const agents = store.state.app.bvs;
    const found_agent = agents.find((agent) => agent.user_id == agent_id);
    return found_agent ? found_agent.name || found_agent.username : "N/F";
}

export function sleep(m) {
    return new Promise((r) => setTimeout(r, m));
}
